import angular from 'angular';
import { environment } from 'environments';

class GeoService {
  /* @ngInject */
  constructor($http, Endpoints, Utils, API_URL) {
    Object.assign(this, {
      $http,
      Endpoints,
      Utils,
      API_URL,
    });
  }

  getAddress(zipcode, countryCode) {
    const country = countryCode || 'UK';
    return this.$http.get(`${this.Endpoints.google.geocodeAddress + zipcode},UK&components=country:${country}&key=${environment.constants.GOOGLE_MAPS_KEY}`, {
      ignoreLoader: true
    });
  }

  getTimezoneFromLatLng(latlng, timestamp) {
    return this.$http.get(`${this.Endpoints.google.timezone + latlng}&timestamp=${timestamp}&key=${environment.constants.GOOGLE_MAPS_KEY}`);
  }

}

GeoService.$inject = ["$http", "Endpoints", "Utils", "API_URL"];
angular.module('pims').service('GeoService', GeoService);
